export const getPostChatChoices = (t) => {
  return {
    howAreYouFeelingChoices: [
      { label: t("howAreYouFeelingQuestion.doingOk"), value: "ok" },
      {
        label: t("howAreYouFeelingQuestion.littleUpset"),
        value: "slightly_upset",
      },
      {
        label: t("howAreYouFeelingQuestion.moderatelyUpset"),
        value: "moderately_upset",
      },
      { label: t("howAreYouFeelingQuestion.veryUpset"), value: "very_upset" },
      {
        label: t("howAreYouFeelingQuestion.extremelyUpset"),
        value: "extremely_upset",
      },
    ],
    helpExtentChoices: [
      { label: t("helpExtentQuestion.helpedALot"), value: "helped_a_lot" },
      {
        label: t("helpExtentQuestion.helpedALittle"),
        value: "helped_a_little",
      },
      { label: t("helpExtentQuestion.didntHelpOrHurt"), value: "neutral" },
      {
        label: t("helpExtentQuestion.madeALittleWorse"),
        value: "made_things_a_little_worse",
      },
      {
        label: t("helpExtentQuestion.madeALotWorse"),
        value: "made_things_a_lot_worse",
      },
    ],
    stopSuicideChoices: [
      {
        label: t("stopSuicideQuestion.notHavingThoughts"),
        value: "no_suicidal_thoughts",
      },
      {
        label: t("stopSuicideQuestion.stoppedALot"),
        value: "stopped_significantly",
      },
      {
        label: t("stopSuicideQuestion.stoppedALittle"),
        value: "stopped_slightly",
      },
      { label: t("stopSuicideQuestion.didntStop"), value: "did_not_stop" },
      {
        label: t("stopSuicideQuestion.madeThingsWorse"),
        value: "exacerbated_condition",
      },
    ],
    counselorConcernedChoices: [
      {
        label: t("counselorConcernedQuestion.stronglyAgree"),
        value: "strongly_agree",
      },
      { label: t("counselorConcernedQuestion.agree"), value: "agree" },
      { label: t("counselorConcernedQuestion.neither"), value: "neutral" },
      { label: t("counselorConcernedQuestion.disagree"), value: "disagree" },
      {
        label: t("counselorConcernedQuestion.stronglyDisagree"),
        value: "strongly_disagree",
      },
    ],
    counselorUnderstoodChoices: [
      {
        label: t("counselorUnderstoodQuestion.stronglyAgree"),
        value: "strongly_agree",
      },
      { label: t("counselorUnderstoodQuestion.agree"), value: "agree" },
      { label: t("counselorUnderstoodQuestion.neither"), value: "neutral" },
      { label: t("counselorUnderstoodQuestion.disagree"), value: "disagree" },
      {
        label: t("counselorUnderstoodQuestion.stronglyDisagree"),
        value: "strongly_disagree",
      },
    ],
    plansAfterChoices: [
      { label: t("plansAfterQuestion.yes"), value: "yes" },
      { label: t("plansAfterQuestion.no"), value: "no" },
    ],
    likelyToFollowPlansChoices: [
      {
        label: t("likelyToFollowPlansQuestion.notLikely"),
        value: "not_likely",
      },
      { label: t("likelyToFollowPlansQuestion.might"), value: "might" },
      {
        label: t("likelyToFollowPlansQuestion.definitelyWill"),
        value: "definite_will",
      },
    ],
    whatPreventedPlansChoices: [
      {
        label: t("whatPreventedPlansQuestion.didNotDiscuss"),
        value: "not_discussed",
      },
      {
        label: t("whatPreventedPlansQuestion.notGoodFit"),
        value: "bad_fit",
      },
      { label: t("whatPreventedPlansQuestion.other"), value: "not_listed" },
    ],
    raceIdentityChoices: [
      {
        label: t("raceIdentityQuestion.americanIndian"),
        value: "native",
      },
      { label: t("raceIdentityQuestion.asian"), value: "asian" },
      { label: t("raceIdentityQuestion.black"), value: "black" },
      { label: t("raceIdentityQuestion.hispanic"), value: "hispanic_latino" },
      {
        label: t("raceIdentityQuestion.middleEastern"),
        value: "middle_eastern_north_african",
      },
      {
        label: t("raceIdentityQuestion.pacificIslander"),
        value: "pacific_islander",
      },
      { label: t("raceIdentityQuestion.white"), value: "white" },
      { label: t("raceIdentityQuestion.moreThanOne"), value: "multiple" },
      {
        label: t("raceIdentityQuestion.notListed"),
        value: "not_listed",
        customInput: true,
      },
      {
        label: t("raceIdentityQuestion.preferNotToAnswer"),
        value: "prefer_not_to_answer",
      },
    ],
    militaryServiceChoices: [
      { label: t("militaryServiceQuestion.activeDuty"), value: "active_duty" },
      {
        label: t("militaryServiceQuestion.reserveDuty"),
        value: "reserve_duty",
      },
      {
        label: t("militaryServiceQuestion.nationalGuard"),
        value: "national_guard",
      },
      { label: t("militaryServiceQuestion.veteran"), value: "veteran" },
      { label: t("militaryServiceQuestion.no"), value: "not_served" },
      {
        label: t("militaryServiceQuestion.preferNotToAnswer"),
        value: "prefer_not_to_answer",
      },
    ],
  };
};
